import { render, staticRenderFns } from "./BtnDeleteChallenge.vue?vue&type=template&id=e8e99baa"
import script from "./BtnDeleteChallenge.vue?vue&type=script&lang=js"
export * from "./BtnDeleteChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports